<app-gradient class="gradient gradient__left"></app-gradient>
<div class="home-purpose__container">
  <h2 class="heading-m home-purpose__title">
    {{ 'home.purpose-section.title' | translate }}
  </h2>
  <div class="home-purpose__content">
    <div class="home-card__container--left">
      <img
        class="home-purpose__image"
        src="/assets/images/phone-illustration-{{ accountService.user().preferredLanguage || LOCALE.ID }}.webp"
        loading="lazy"
        alt="logo"
        appBgImgFallback
        [fallbackBgImageUrl]="'/assets/images/phone-illustration-'+ accountService.user().preferredLanguage || LOCALE.ID +'.png'" />
    </div>
    <div class="home-card__container--right">
      <app-vertical-step-card
        icon="fragrance_selection"
        title="{{ 'home.purpose-section.find-inspiration-title' | translate }}"
        description="{{
        'home.purpose-section.find-inspiration-description' | translate
      }}">
      </app-vertical-step-card>
      <app-transition-step-card [isBackgroundReversed]="true" class="home-purpose__transition-card" description="{{ 'home.purpose-section.after-one-two-days' | translate }}" >
      </app-transition-step-card>
      <app-vertical-step-card
        icon="website-icon"
        title="{{ 'home.purpose-section.receive-fragrance-title' | translate }}"
        description="{{
        'home.purpose-section.receive-fragrance-description' | translate
      }}">
      </app-vertical-step-card>
      <app-transition-step-card class="home-purpose__transition-card" description="{{ 'home.purpose-section.after-one-two-days' | translate }}" >
      </app-transition-step-card>
      <app-vertical-step-card
        icon="delivery"
        title="{{ 'home.purpose-section.launch-product-title' | translate }}"
        description="{{
        'home.purpose-section.launch-product-description' | translate
      }}">
      </app-vertical-step-card>
    </div>
  </div>
</div>
